import validate from './validate';

const validators = {
  has16Digits: value => /^\d{16}$/i.test(value)
};

const validatorsLive = {
  has16Digits: value => /^\d{1,16}$/i.test(value)
};

const validationErrors = {
  has16Digits: 'Must be 16 digits!'
};

export const checkCardNumberLive = (
  cardNumber => validate(cardNumber, validatorsLive, validationErrors)
);

export const checkCardNumber = (
  cardNumber => validate(cardNumber, validators, validationErrors)
);

export default checkCardNumber;
